(() => {
    const invetoryVehicles = document.querySelectorAll('[data-vd-component="inventory-vehicles"]');
    if (!invetoryVehicles) return;

    invetoryVehicles.forEach((inventory) => {
        const model = inventory.getAttribute("data-model");
        const dataLanguage = inventory.getAttribute("data-language") || "en";
        const dataLiterals = inventory.getAttribute("data-literals");
        const literals = dataLiterals ? JSON.parse(dataLiterals) : {};

        const viewAllContainer = inventory.querySelector(".view-all-container");

        const query = model ? `&query=${model}` : "";

        // Fetch vehicles from API
        fetch(`/engine/esqueryIndex?type=products${query}&searchtype=bycode&lang=${dataLanguage}&pagesize=9`)
            .then((response) => {
                if (!response.ok) throw new Error("Network response was not ok");
                return response.json();
            })
            .then((data) => {
                if (data && data.hits && data.hits.hits && data.hits.hits.length > 0) {
                    handleResponse(data.hits.hits);
                } else {
                    errorNotFound();
                }
            })
            .catch(() => {
                errorNotFound();
            });

        function handleResponse(vehicles) {
            const slicedVehicles = vehicles.slice(0, 8);
            const vehiclesHTML = slicedVehicles.map((vehicle) => renderVehicle(vehicle)).join("");

            const vehiclesList = inventory.querySelector(".inventory-vehicles-list");
            if (vehiclesList) {
                vehiclesList.innerHTML = vehiclesHTML;
            } else {
                console.error("Vehicles list container not found");
            }

            inventory.classList.add("loaded");

            if (vehicles.length > 8 && viewAllContainer) {
                viewAllContainer.classList.add("has-more-items");
            }
        }

        function renderVehicle(vehicle) {
            let image = "";
            if (vehicle._source.BoxImage && vehicle._source.BoxImage[0] && vehicle._source.BoxImage[0].Src) {
                image = vehicle._source.BoxImage[0].Src;
            } else {
                console.warn(`No box image found for vehicle: ${vehicle}`);
            }

            let title = "";
            if (vehicle._source.Title) {
                title = vehicle._source.Title;
            } else {
                console.warn(`No title found for vehicle: ${vehicle}`);
            }

            const attributes = {};
            if (vehicle._source.Attributes) {
                const isUsedAttribute = vehicle._source.Attributes.find((attr) => attr.Code === "ItemAttributes_isused");
                const isUsed = isUsedAttribute ? isUsedAttribute.Value : false;

                for (const attribute of vehicle._source.Attributes) {
                    if (
                        attribute.Code == "ItemAttributes_modelyear" ||
                        attribute.Code == "ItemAttributes_fuelused" ||
                        (isUsed && attribute.Code == "ItemAttributes_odometer") ||
                        (!isUsed && attribute.Code == "ItemAttributes_seatingcapacity")
                    ) {
                        attributes[attribute.Code] = { Value: attribute.Value, Name: attribute.Name };
                    }
                }
            }

            let price = "";
            if (
                vehicle.fields &&
                vehicle.fields.FinalPrices &&
                vehicle.fields.FinalPrices.length > 0 &&
                vehicle.fields.FinalPrices[0] &&
                vehicle.fields.FinalPrices[0].DisplayPrice &&
                vehicle.fields.FinalPrices[0].DisplayPrice.DisplayTotalValue
            ) {
                price = vehicle.fields.FinalPrices[0].DisplayPrice.DisplayTotalValue;
            } else {
                console.warn(`No final prices found for vehicle: ${vehicle}`);
            }

            let vehicleUrl = "#";
            if (vehicle._source.Url) {
                vehicleUrl = vehicle._source.Url;
            } else {
                console.warn(`No URL found for vehicle: ${vehicle}`);
            }

            return `<div class="vehicle-model-card swiper-slide">
                        <a class="vehicle-model-card-link-wrapper" href="${vehicleUrl}">
                            <figure class="image">
                                <picture class="picture">
                                    <img src="${image}" alt="${title}" class="image cover">
                                </picture>
                            </figure>
                            <div class="content-wrapper">
                                <div class="info">
                                    <h2 class="title">${title}</h2>
                                    <div class="attributes-container">
                                        <ul class="attributes-list">
                                            ${Object.keys(attributes)
                                                .map((key) => {
                                                    return `<li class="attribute ${key.toLowerCase()}">
                                                            <span class="label">${attributes[key].Name}</span>                                                        
                                                            <div class="value-container">
                                                                ${
                                                                    Array.isArray(attributes[key].Value)
                                                                        ? attributes[key].Value.map((val) => `<span class="value">${val}</span>`).join("")
                                                                        : `<span class="value">${attributes[key].Value}</span>`
                                                                }
                                                            </div>
                                                        </li>`;
                                                })
                                                .join("")}                                     
                                        </ul>
                                    </div>
                                    <div class="price">                                    
                                        <span class="value">
                                            <span class="symbol">&#xea;</span>
                                            ${price.substring(2, price.length)}
                                        </span> 
                                    </div>
                                </div>
                                <div class="actions">                               
                                    <span class="btn fourth">
                                        <span class="label">${literals && literals.details}</span>
                                    </span>
                                </div>
                            </div>
                        </a>
                    </div>`;
        }

        function errorNotFound() {
            const noVehiclesMessage = inventory.querySelector(".no-vehicles-message");
            if (noVehiclesMessage) {
                noVehiclesMessage.style.display = "block";
            }
        }
    });
})();
